import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import { LocalizedLink } from '@/components/LocalizedLink'

export function DiscoverProducts() {
  const { t } = useTranslation('common')

  return (
    <section className="relative overflow-hidden bg-[#2A0E0E] py-20 md:py-28">
      {/* Grain */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Top accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#DF631E]/40 to-transparent" />

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-[#DF631E]" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-[#DF631E]">
              {t('nav.products')}
            </span>
          </div>

          <h2
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-[1.1] mb-5"
            style={{ fontFamily: 'Playfair Display, Georgia, serif' }}
          >
            {t('about.cta.title')}
          </h2>

          <p className="text-base md:text-lg text-white/50 max-w-lg leading-relaxed mb-8">
            {t('about.cta.description')}
          </p>

          <LocalizedLink
            to="products"
            className="group inline-flex items-center gap-3 px-7 py-3.5 bg-[#DF631E] text-white text-sm font-semibold tracking-wide uppercase hover:bg-[#B85018] transition-colors duration-300"
          >
            {t('about.cta.button')}
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </LocalizedLink>
        </div>
      </div>
    </section>
  )
}
